import Base from './Base';

const ENTITY = 'news';
export const REDUCER_NAME = 'notice';

const initialState = { isFetching: true, isSingleObject: true, values: {} };
const notice = new Base(ENTITY, initialState);

export const reducer = notice.reducer.bind(notice);
notice.getAsync.bind(notice);
notice.putAsync.bind(notice);
notice.postAsync.bind(notice);

export const get = (id) => {
  return notice.getAsync(`${ENTITY}/${id}`);
};

export const put = (id, data) => {
  return notice.putAsync(`${ENTITY}/${id}`, data);
};



// WEBPACK FOOTER //
// ./src/redux/modules/notice.js